import {
  PRODUCT_META,
  PRODUCT_META_LIST,
  ProductStatus,
  productEntry,
  type AuthUser,
  type ProductCode,
} from '@gb-ticket/shared-types';

export type PlatformProductTile = {
  code: ProductCode;
  labelDe: string;
  descriptionDe: string;
  status: 'live' | 'planned';
  /** Target path when the product is in session products[]; null when planned/hidden. */
  href: string | null;
};

export const START_PATH = '/start';

/** Product entry from PRODUCT_META: staff at `pathPrefix`, everyone else at `selfServicePath`. */
export function productHrefFor(code: ProductCode, user: AuthUser): string {
  return productEntry(code, user.permissions).path;
}

/** Path prefixes a product owns (staff area and self-service), for "is this deep link inside X". */
export function productPathPrefixes(code: ProductCode): string[] {
  const meta = PRODUCT_META[code];
  return meta.selfServicePath ? [meta.pathPrefix, meta.selfServicePath] : [meta.pathPrefix];
}

/**
 * Hub tiles from PRODUCT_META + session products[].
 * - In products[] → live, clickable
 * - planned (not in products[]) → "Demnächst"
 * - live but not in products[] → hidden (no permission / company-disabled)
 */
export function platformProductTiles(user: AuthUser): PlatformProductTile[] {
  const allowed = new Set(user.products ?? []);
  const tiles: PlatformProductTile[] = [];

  for (const meta of PRODUCT_META_LIST) {
    if (allowed.has(meta.code)) {
      tiles.push({
        code: meta.code,
        labelDe: meta.labelDe,
        descriptionDe: meta.descriptionDe,
        status: 'live',
        href: productHrefFor(meta.code, user),
      });
      continue;
    }
    if (meta.status === ProductStatus.PLANNED) {
      tiles.push({
        code: meta.code,
        labelDe: meta.labelDe,
        descriptionDe: meta.descriptionDe,
        status: 'planned',
        href: null,
      });
    }
  }

  return tiles;
}
